import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/services/supabase';

// Token-handoff page used by the native app's AdminConsoleScreen WebView.
// Reads access_token + refresh_token from the URL fragment, sets the Supabase
// session, then redirects to the requested admin page (defaulting to '/').
export default function MobileCallback() {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    const hash = window.location.hash || '';
    const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
    const access_token = params.get('access_token');
    const refresh_token = params.get('refresh_token');
    const redirect = params.get('redirect') || '/';

    if (!access_token || !refresh_token) {
      setErrorMessage('Missing authentication tokens.');
      return;
    }

    supabase.auth
      .setSession({ access_token, refresh_token })
      .then(({ error }) => {
        if (error) {
          setErrorMessage(error.message || 'Failed to establish session.');
          return;
        }
        navigate(redirect, { replace: true });
      })
      .catch((err) => {
        setErrorMessage(err?.message || 'Failed to establish session.');
      });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="flex flex-col items-center gap-4">
        {errorMessage ? (
          <>
            <p className="text-red-600 text-center max-w-sm">{errorMessage}</p>
            <button
              type="button"
              className="px-4 py-2 bg-brand text-white rounded"
              onClick={() => navigate('/login', { replace: true })}
            >
              Go to login
            </button>
          </>
        ) : (
          <>
            <div className="w-10 h-10 border-4 border-brand border-t-transparent rounded-full animate-spin" />
            <p className="text-gray-500">Signing you in…</p>
          </>
        )}
      </div>
    </div>
  );
}
